import { Component, OnInit, ViewEncapsulation, OnDestroy, ChangeDetectorRef, AfterViewChecked } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { fuseAnimations } from '@fuse/animations';
import { BaseService } from 'app/_helpers/base/base.service';
import { Subject } from 'rxjs';
import { startWith, tap, takeUntil, switchMap } from 'rxjs/operators';

@Component({
  selector: 'app-wg-account-assignment',
  templateUrl: './wg-account-assignment.component.html',
  styleUrls: ['./wg-account-assignment.component.scss'],
  encapsulation: ViewEncapsulation.None,
  animations: fuseAnimations
})
export class WgAccountAssignmentComponent implements OnInit, OnDestroy, AfterViewChecked {

  accountsAssignmentRange: UntypedFormControl = new UntypedFormControl('today');
  accountsAssignmentData: any = {};
  loadData: boolean;

  private _unsubscribeAll: Subject<any>;

  constructor(
    private cdref: ChangeDetectorRef,
    private _gService: BaseService
  ) {
    this._unsubscribeAll = new Subject();
  }

  ngOnInit(): void {

    this.accountsAssignmentRange.valueChanges
      .pipe(
        startWith('today'),
        tap(() => this.loadData = true),
        takeUntil(this._unsubscribeAll),
        switchMap((range: string) => {
          return this._gService.post(`dashboard/accounts_assignments?range=${range}`, {}, 'nodejs');
        })
      )
      .subscribe((data: any) => {
        this.accountsAssignmentData = data;
        this.loadData = false;
      }, () => this.loadData = false);

  }

  ngAfterViewChecked(): void {
    this.cdref.detectChanges();
  }

  ngOnDestroy(): void {
    this._unsubscribeAll.next();
    this._unsubscribeAll.complete();
  }

}
